import { render } from "./leftnav.vue?vue&type=template&id=3c935834&scoped=true"
import script from "./leftnav.vue?vue&type=script&lang=js"
export * from "./leftnav.vue?vue&type=script&lang=js"

import "./leftnav.vue?vue&type=style&index=0&id=3c935834&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c935834"]])

export default __exports__